<template>
    <section id="sectionPrincipal" class="catalog-forecast-market">
        <Loader v-if="loading" :loading="loading" :fixed="true"></Loader>
        <template v-if="periodHasZones.length && periodHasZone">
            <component
                :is="CatalogForecastMarket"
                v-if="props"
                v-bind="props"
                @change="changePeriod"
                @reload="loadPeriodHasZone"
                @updateIsEdit="updateIsEdit"
            ></component>
        </template>
        <template v-else>
            <div class="no-period">{{ $t("catalogForecast.market.noPeriod") }}</div>
        </template>
    </section>
</template>
<script>
import CatalogForecastMarket from "@/components/catalogForcast/elements/CatalogForecastMarket";
import Loader from "@/components/loader/loader";
import { FUNCTIONALITY } from "@/components/catalogForcast/constants";
import periodHasZoneService from "@/services/cfPeriodHasZones";
import categorieService from "@/services/categories";
import { moment } from "@/utils/moment";
import cacheService from "@/services/cache";
import { APPLICATION, APPLICATION_PARAMETER } from "@/components/admin/brand/constant";
import brandApplicationHasParametersService from "@/services/brandApplicationHasParameters";
import { PROFILES } from "@/plugins/constant";

export default {
    components: { CatalogForecastMarket, Loader },
    data() {
        return {
            PROFILES,
            APPLICATION,
            APPLICATION_PARAMETER,
            props: null,
            FUNCTIONALITY,
            loading: false,
            periodHasZones: [],
            periodHasZone: null,
            categories: [],
            filters: new Map(),
            zoneId: cacheService.getCurrentZoneId(),
            paramAddImagesToArticles: null,
            isEditing: false,
            CatalogForecastMarket
        };
    },
    computed: {},
    methods: {
        getDate(date, format, start = "second") {
            return moment(date, "YYYYMM")
                .startOf("month")
                .format(format)
                .toUpperCase();
        },
        async loadPeriodHasZone(pzId) {
            this.loading = true;
            this.periodHasZones = await periodHasZoneService.getAllForMarket(this.zoneId);
            const currentPz = this.periodHasZones.find(pz => pz.period.isOpened);
            const currentPzId = pzId ? pzId : currentPz ? currentPz.id : null;

            if (currentPzId) {
                this.periodHasZone = await periodHasZoneService.get(pzId ? pzId : currentPz.id);
                this.filters.set("pzId", this.periodHasZone.id);
                this.loadProps();
            }
            this.loading = false;
        },
        changePeriod(periodHasZone) {
            this.loadPeriodHasZone(periodHasZone.id);
        },
        updateIsEdit(value) {
            this.isEditing = value;
            this.loadProps();
        },
        loadProps() {
            this.props = {
                key: this.periodHasZone.id,
                periodHasZone: this.periodHasZone,
                periodHasZones: this.periodHasZones,
                filters: this.filters,
                categories: this.categories,
                paramAddImagesToArticles: this.paramAddImagesToArticles,
                isEditing: this.isEditing,
                reload: true
            };
        },
        warningSaveQuantities() {
            if (!this.isEditing) {
                return new Promise(resolve => resolve(true));
            }
            return this.$swal({
                html: this.$t("catalogForecast.market.warningSave"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "red",
                confirmButtonText: this.$t("common.yes").toUpperCase(),
                cancelButtonText: this.$t("common.no").toUpperCase(),
                closeOnConfirm: true
            });
        }
    },
    async created() {
        this.loading = true;
        this.paramAddImagesToArticles = await brandApplicationHasParametersService.findByBrandAndApplicationAndParameter(
            APPLICATION.CATALOG_FORECAST_ID,
            APPLICATION_PARAMETER.ADD_IMAGES_TO_ARTICLES_ID
        );
        this.categories = await categorieService.getAll();
        await this.loadPeriodHasZone();
        this.loading = false;
    },
    async beforeRouteLeave(to, from, next) {
        if (!this.isEditing) {
            next();
        } else {
            if (await this.warningSaveQuantities()) {
                next();
            } else {
                next(false);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.catalog-forecast-market {
    background-color: #fff;
    margin-top: 30px;
    .no-period {
        font-size: 16px;
        padding: 50px;
        display: flex;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// CatalogForecastMarketFromMenu.vue?777cf4a6